// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"acd3002959349973e89e","655":"7a5f535280e376d13e29"}[chunkId] + ".js";
};